// extracted by mini-css-extract-plugin
export default {"modalContainer":"LSam","formTitle":"sfNp","cardsContainer":"fmpE","inputContainer":"sfvr","linkContainer":"KrTj","boldText":"xeBZ","emptyStateChildrenContainer":"VaqV"};